import React, { useEffect, useRef, useState } from 'react';
import { Check } from 'lucide-react';

/** Hoverable benefit pills (left) driving a glass detail card (right). */
const RentAiBenefits = ({ items, logo, label }) => {
  const [active, setActive] = useState(0);
  const current = items[active] || items[0];

  // Card pours into place the first time it scrolls into view.
  const cardRef = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const node = cardRef.current;
    if (!node) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      setRevealed(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setRevealed(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div>
      {label && <p className="mpa-card-subhead">{label}</p>}

      <div className="mpa-ai">
        {/* Left — hoverable bullet list in two columns */}
        <ul className="mpa-ai-list">
          {items.map((item, i) => {
            const isActive = i === active;
            return (
              <li key={item.name}>
                <button
                  type="button"
                  onMouseEnter={() => setActive(i)}
                  onFocus={() => setActive(i)}
                  onClick={() => setActive(i)}
                  aria-pressed={isActive}
                  className={`mpa-ai-pill mpa-liquid-hover${isActive ? ' is-active' : ''}`}
                >
                  <span className="mpa-ai-pill-check">
                    <Check size={12} strokeWidth={3} />
                  </span>
                  <span className="mpa-ai-pill-name">{item.name}</span>
                </button>
              </li>
            );
          })}
        </ul>

        {/* Right — glass card reflecting the hovered bullet */}
        <div className="mpa-ai-card-wrap">
          <div ref={cardRef} className={`mpa-ai-card${revealed ? ' mpa-liquid-in' : ' mpa-hidden'}`}>
            {/* Sheen re-fires on each selection, reading as fluid under glass. */}
            <span key={`sheen-${active}`} className="mpa-liquid-sheen" aria-hidden="true" />

            <div key={`head-${active}`} className="mpa-liquid-morph mpa-ai-head">
              {logo && (
                <span className="mpa-ai-logo" aria-hidden="true">
                  <img src={logo} alt="" />
                </span>
              )}
              <p className="mpa-ai-title">{current.name}</p>
            </div>

            <p
              key={`copy-${active}`}
              className="mpa-liquid-morph mpa-ai-copy"
              style={{ animationDelay: '70ms' }}
            >
              {current.copy}
            </p>

            <div className="mpa-ai-dots" aria-hidden="true">
              {items.map((item, i) => (
                <span
                  key={item.name}
                  className={`mpa-ai-dot${i === active ? ' is-active' : ''}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentAiBenefits;
